export default __webpack_public_path__ + "static/media/CreateComp.16414a5b.svg";